import React from 'react';
import { cn } from '../../lib/utils';
export { Badge } from '../../internal/primitives/badge';
export { Checkbox } from '../../internal/primitives/checkbox';
export { Tabs, TabsContent, TabsList, TabsTrigger } from '../../internal/primitives/tabs';

export interface SilkSelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'onChange'> {
  onValueChange?: (value: string) => void;
  options?: Array<{ label: string; value: string }>;
  className?: string;
}

export function SilkSelect({ className, children, options, onValueChange, ...props }: SilkSelectProps) {
  return (
    <select
      className={cn(
        'h-8 rounded border border-border/50 bg-background px-2 text-xs font-medium text-foreground transition-colors hover:border-border focus:outline-none focus:ring-1 focus:ring-ring disabled:opacity-50',
        className
      )}
      onChange={(e) => onValueChange?.(e.target.value)}
      {...props}
    >
      {options
        ? options.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))
        : children}
    </select>
  );
}

export function SilkInput({ className, ...props }: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={cn(
        'h-8 w-full rounded border border-border/50 bg-background px-2 text-xs text-foreground placeholder:text-muted-foreground/50 transition-colors hover:border-border focus:outline-none focus:ring-1 focus:ring-ring disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
}
